import React, { CSSProperties, FC, MouseEvent } from "react";

import styled from "styled-components";
import Button from "@mui/material/Button";

import { YellowPlus } from "@/assets/icons";

type ButtonType = "button" | "submit" | "reset";

type AddButtonProps = {
    label: string;
    type?: ButtonType;
    disabled?: boolean;
    onClick?: (event: MouseEvent) => void;
    style?: CSSProperties;
};

export const StyledAddButton = styled(Button)`
    &.root {
        font-size: var(--size-14);
        font-style: normal;
        font-weight: bold;
        color: var(--color-secondary);
        text-transform: none;
        white-space: nowrap;
    }

    &:disabled {
        color: var(--color-grey-700);

        svg {
            circle {
                fill: var(--color-grey-700);
            }

            rect {
                fill: var(--color-grey-700);
            }
        }
    }

    &:hover {
        background-color: inherit;
    }

    &:active,
    &.focusVisible {
        background-color: inherit;
        color: var(--color-secondary-tint);

        svg {
            filter: brightness(0.8);
        }
    }

    &.text {
        padding: 0 8px;
    }
`;

const AddButton: FC<AddButtonProps> = ({ label, style, disabled = false, ...rest }) => {
    return (
        <StyledAddButton
            classes={{ root: "root", text: "text" }}
            focusVisibleClassName="focusVisible"
            variant="text"
            className="addButton"
            disableRipple
            disableTouchRipple
            startIcon={<YellowPlus />}
            disabled={disabled}
            style={style}
            type="button"
            {...rest}
        >
            {label}
        </StyledAddButton>
    );
};

export default AddButton;
